<div id="m-s-container">
  <div id="m-s-head" *ngIf="header" class="title">{{ header }}</div>
  <p-multiSelect
    appendTo="body"
    [options]="list"
    [(ngModel)]="selectedItem"
    (ngModelChange)="onChange($event, selectedItem)"
    placeholder ="Select"
    optionLabel="name"
    [selectionLimit]="selectionLimit"
    [disabled]="disabled"
    [showToggleAll]="toggleAll"
  >
    <ng-template id="m-s-drpdwn" let-value pTemplate="selectedItems">
      <div
        class="country-item country-item-value"
        *ngIf="selectedItem && selectedItem.length > 1"
        [title]="displaySelectName+'...'+ ' + '+ displaySelectCount+ ' Others'"
      >
        <div>{{ displaySelectName }}...+ {{ displaySelectCount }} Others</div>
      </div>
      <div
        class="country-item country-item-value"
        *ngIf="selectedItem && selectedItem.length === 1"
      >
        <div>{{ displaySelectName }}</div>
      </div>
      <div
        *ngIf="!selectedItem || selectedItem.length === 0"
        class="country-placeholder"
      >
        {{ placeHolderText }}
      </div>
    </ng-template>
    <!-- <ng-template let-country pTemplate="item">
      <div class="country-item">
        <div>
          <span *ngIf="icon"
            ><em
              class="pi pi-circle-on status-icon"
              [ngStyle]="{ color: country.value.id }"
            ></em> </span
          >{{ country.value.name }}
        </div>
      </div>
    </ng-template> -->
  </p-multiSelect>
</div>
